import { useState, useEffect } from 'react'
import { Text, Container } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { FeatureToggleV2Type, FixedContainerV2, useFeatureToggleV2Store } from '@slot-nx/core'
import { t, Image } from '@slot-nx/core'
import { gameConfig } from '../../config'

export let isShowChangePose = false

export const ChangePose = () => {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const detectOrientation = () => {
      const enableChangePose = useFeatureToggleV2Store.getState().toggleListV2.has(FeatureToggleV2Type.enableChangePose)
      const isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      if (enableChangePose && window.innerWidth > window.innerHeight && isMobile) {
        setIsActive(true)
        isShowChangePose = true
      }
      else {
        setIsActive(false)
        isShowChangePose = false
      }
    }
    detectOrientation()
    window.addEventListener('resize', detectOrientation)
    window.addEventListener('orientationchange', detectOrientation)
    return () => {
      window.removeEventListener('resize', detectOrientation)
      window.removeEventListener('orientationchange', detectOrientation)
    }
  }, [isActive])

  if (!isActive) return null

  return (
    <Container x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height / 2} scale={2}>
      <FixedContainerV2
        name="change pose"
        width={3240 / 2}
        height={1920 / 2}
        x={-3240 / 2 / 2}
        y={-1920 / 2 / 2}
        background="#000"
        blockEvents
      >
        <Image
          x={(3240 - 300) / 2 / 2}
          y={(1920 - 300) / 2 / 2 - 100}
          width={300 / 2}
          height={300 / 2}
          image="changePose"
        />
        <Text
          text={(t('changePose'))}
          anchor={[0.5, 0.5]}
          x={3240 / 2 / 2}
          y={1920 / 2 / 2 + 100}
          style={
            new TextStyle({
              fontSize: 100 / 2,
              fill: 'ffffff',
              align: 'center',
            })
          }
        />
      </FixedContainerV2>
    </Container>

  )
}
